<template>
  <div class="">
    <a-upload accept=".mp4,.MOV" list-type="picture" v-model:file-list="fileList" @preview="handlePreview"
      :multiple="true" :before-upload="beforeUpload" :customRequest="customRequest" @change="handleUploadChange"
      :showUploadList="true" :disabled="canuseUpload">
      <div v-if="(props.maxCount && fileList.length < props.maxCount) || !props.maxCount">
        <plus-outlined />
        <div class="ant-upload-text">上传视频</div>
      </div>
    </a-upload>
  </div>

  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
    <video :src="previewVideo" style="width: 400px" controls controlsList="nodownload"></video>
  </a-modal>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { uploadAttachment } from "@/request/view/repair";
import { useStore } from "vuex";
import { message } from "ant-design-vue";

export default defineComponent({
  props: {
    attachment: String,
    disabled: Boolean,
    requestFn: Function,
    maxCount: Number,
    uploadFileName: String,
  },
  setup(props, context) {
    const store = useStore();
    const fileList = ref([]);
    const previewVisible = ref(false);
    const previewVideo = ref("");
    const canuseUpload = ref(false);
    const handlePreview = async (file) => {
      if (file.url) {
        previewVideo.value = file.url;
      }
      previewVisible.value = true;
    };

    const setFileList = (list) => {
      const time = new Date();
      list.forEach((url) => {
        const name = url.slice(url.lastIndexOf("/") + 1, url.length);
        fileList.value.push({
          uid: time.getTime() + Math.random(5),
          status: "done",
          name,
          url,
        });
      });
    };

    const beforeUpload = (file) => {
      const isVideo = file.type.indexOf("video") !== -1;
      if (!isVideo) {
        message.error("请上传视频");
      }
      return isVideo;
    };

    const handleUploadChange = (file) => {
      file.file.status = "done";
    };

    const uploadFile = (cb) => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        let needUpload = false;
        fileList.value.forEach((file) => {
          if (file.url) {
            return;
          }
          needUpload = true;
          const fileName = props.uploadFileName ? props.uploadFileName : 'files';
          formData.append(fileName, file.originFileObj);
        });

        if (!needUpload) {
          let fileUrl = [];
          fileList.value.forEach((item) => {
            fileUrl.push(item.url);
          });
          resolve(fileUrl);
          return;
        }
        if (cb) cb();
        let reqFn =
          props.requestFn === undefined ? uploadAttachment : props.requestFn;
        reqFn(formData)
          .then((res) => {
            if (res.code === 200) {
              const cacheFile = [];
              fileList.value.forEach((item) => {
                if (item.url) {
                  cacheFile.push(item.url);
                }
              });
              if (Object.prototype.toString.call(res.data) === '[object Array]') {
                cacheFile.push(...res.data);
              }
              if (Object.prototype.toString.call(res.data) === '[object String]') {
                cacheFile.push(res.data);
              }
              resolve(cacheFile);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const customRequest = (info) => {
      previewVideo.value = URL.createObjectURL(info.file);
    };

    const handleCancel = () => {
      previewVisible.value = false;
    };

    const isVideo = (str) =>
      str.indexOf("mp4") !== -1 || str.indexOf("MOV") !== -1;

    const getFile = (str) => {
      str = String(str);
      if (str.indexOf('[') !== -1) {
        return JSON.parse(str);
      }
      return str.split(',')
    };

    watch(
      () => props.attachment,
      (val) => {
        fileList.value.length = 0;
        if (!val) return;
        const videoList = getFile(val).filter((item) => isVideo(item));
        setFileList(videoList);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.disabled,
      (val) => {
        canuseUpload.value = val;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      handlePreview,
      fileList,
      previewVisible,
      handleCancel,
      previewVideo,
      beforeUpload,
      customRequest,
      handleUploadChange,
      uploadFile,
      canuseUpload,
    };
  },
});
</script>

<style lang="less" scoped>
.ant-upload-text {
  padding: 5px 10px;
  border: 1px solid #ccc;
}
</style>
